import React, { useReducer } from 'react';
import classNames from 'classnames';
import SegmentedControl from '../segmentedControl/SegmentedControl';
import CTAButton from '../ctaButton/CTAButton';
import stepOne from '../../../content/media-library/joint/step-one.png';
import stepTwo from '../../../content/media-library/joint/step-two.png';
import stepThree from '../../../content/media-library/joint/step-three.png';
import bothStepOne from '../../../content/media-library/joint/step-one-both-do.png';
import bothStepTwo from '../../../content/media-library/joint/step-two-both-do.png';
import * as classes from './StepsJCA.module.scss';

const StepsJCA = () => {
  const initialState = {
    selected: 'nobody',
    items: [
      { id: 'nobody', value: 'nobody', label: 'Neither of us do' },
      { id: 'bothPeople', value: 'bothPeople', label: 'We both do' },
      { id: 'onePerson', value: 'onePerson', label: 'One of us does' }
    ]
  };

  const reducer = (state, action) => {
    if (action.type === 'changeSelection') {
      return { ...state, selected: action.payload };
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const options = {
    nobody: {
      name: state.items[0].label,
      steps: [
        {
          image: stepOne,
          altText: 'Starling Bank card',
          description: (
            <span>
              To open a joint account, you’ll both need our award-winning personal account first. It only takes a few
              minutes to apply for one – all from your phone.
            </span>
          )
        },
        {
          image: stepTwo,
          altText: 'A screen in the Starling Bank app promting the user to open a new account',
          description: (
            <span>
              Personal accounts set up? Make sure you’re both in the same room, then tap the account switcher above your
              balance. Tap <strong>Open a new account.</strong>
            </span>
          )
        },
        {
          image: stepThree,
          altText: 'A screen in the Starling Bank app promting the user to create a joint account',
          description:
            'Choose the joint account, then follow the steps to apply. As soon as we’ve checked your details, your new account will be open and ready to use. '
        }
      ],
      link: 'https://www.starlingbank.com/apply/?r=pca'
    },
    bothPeople: {
      name: state.items[2].label,
      images: [bothStepOne, bothStepTwo, stepThree],
      steps: [
        {
          image: bothStepOne,
          altText: 'A woman and a man both looking at a phone smiling',
          description:
            'Great! Make sure you’re both in the same room, with your Bluetooth turned on. Then complete these following steps together.'
        },
        {
          image: bothStepTwo,
          altText: 'A screen in the Starling Bank app promting the user to open a new account',
          description: (
            <span>
              From the app’s homescreen, tap the account switcher above your balance. Tap{' '}
              <strong>Open a new account</strong>, then choose the joint account.
            </span>
          )
        },
        {
          image: stepThree,
          altText: 'A screen in the Starling Bank app promting the user to create a joint account',
          description:
            'Follow the steps to apply. Then as soon as we’ve checked your details, your new account will be open and ready to use. '
        }
      ]
    }
  };

  const hasStarling = state.selected === 'bothPeople';

  return (
    <div id="set-up" className={classes.stepsJCA}>
      <h2>How to open a joint account</h2>
      <p>Opening a joint account is easy – and all online. Do either of you bank with Starling already?</p>
      <div className={classes.segmentedControlWrapper}>
        <SegmentedControl state={state} dispatch={dispatch} dispatchAction="changeSelection" />
      </div>

      <div className={classes.steps}>
        {options[state.selected === 'bothPeople' ? 'bothPeople' : 'nobody'].steps.map((step, index) => {
          return (
            <div className={classes.step} key={`JCA opening step ${index + 1} ${state.selected}`}>
              <img src={step.image} alt={step.altText} />
              <h4>Step {index + 1}</h4>
              <p>{step.description}</p>
            </div>
          );
        })}
      </div>
      <div className={hasStarling ? classes.ctaWrapper : undefined}>
        <CTAButton
          text={hasStarling ? 'Open the app' : 'Apply now'}
          colourScheme={!hasStarling ? 'teal' : 'ghost-purple'}
          className={classNames({
            'btn-download-app': !hasStarling,
            'cta-button--secondary': hasStarling
          })}
          link={hasStarling ? 'starlingbank://launch' : '/apply/?r=pca'}
        />
      </div>
      <p className={classes.footer}>
        Subject to eligibility criteria: the option to apply for a joint account in the app will only be visible for
        customers that match our criteria
      </p>
    </div>
  );
};

export default StepsJCA;
